import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ShieldCheck, ShieldAlert } from 'lucide-react';
import './CertificateVerify.css';

const CertificateVerify = () => {
  const { certificateId } = useParams();
  const [loading, setLoading] = useState(true);
  const [certificateData, setCertificateData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyCertificate = async () => {
  try {
    // Automatically switches between localhost and production domain
    const baseUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
    
    const response = await fetch(`${baseUrl}/api/courses/certificates/verify/${certificateId}/`);
    const data = await response.json();

    if (response.ok && data.verified) {
      setCertificateData(data);
    } else {
      setError(data.error || 'Certificate not found or invalid.');
    }
  } catch (err) {
    setError('Failed to connect to the verification server. Please try again later.');
  } finally {
    setLoading(false);
  }
};

    if (certificateId) {
      verifyCertificate();
    }
  }, [certificateId]);

  if (loading) {
    return (
      <div className="verify-container">
        <div className="verify-card">
          <div className="verify-spinner"></div>
          <p className="verify-loading-text">Verifying credential security...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`verify-container ${error ? '' : 'verify-container-success'}`}>
      {!error && (
        <div className="verify-background-celebration" aria-hidden="true">
          {Array.from({ length: 18 }, (_, index) => (
            <span
              key={index}
              className={`background-spark background-spark-${index + 1}`}
            />
          ))}
          {Array.from({ length: 8 }, (_, index) => (
            <span
              key={`ribbon-${index}`}
              className={`background-ribbon background-ribbon-${index + 1}`}
            />
          ))}
          <span className="background-balloon background-balloon-left" />
          <span className="background-balloon background-balloon-right" />
        </div>
      )}
      <div className="verify-card">
        <div className="verify-header">
          <h2 className="verify-title">TrekVerse Security</h2>
          <p className="verify-subtitle">Credential Verification Portal</p>
        </div>
        
        {error ? (
          <div className="verify-body">
            <div className="verify-icon error-glow">
              <ShieldAlert size={64} className="icon-svg icon-error" strokeWidth={1.5} />
            </div>
            <h3 className="verify-status-title">Verification Failed</h3>
            <p className="verify-error-text">{error}</p>
            <Link to="/" className="verify-button verify-button-error">Return to Homepage</Link>
          </div>
        ) : (
          <div className="verify-body verify-success-body animate-fade-in">
            <div className="verify-celebration-layer" aria-hidden="true">
              {Array.from({ length: 14 }, (_, index) => (
                <span
                  key={index}
                  className={`celebration-burst celebration-burst-${index + 1}`}
                />
              ))}
              <span className="celebration-balloon celebration-balloon-1" />
              <span className="celebration-balloon celebration-balloon-2" />
              <span className="celebration-balloon celebration-balloon-3" />
            </div>
            <div className="verify-icon success-glow">
              <ShieldCheck size={64} className="icon-svg icon-success" strokeWidth={1.5} />
            </div>
            <p className="verify-congrats-kicker">Congratulations</p>
            <h3 className="verify-status-title verify-congrats-title">Certificate Verified</h3>
            <p className="verify-congrats-message">
              This credential has been authenticated by TrekVerse.
            </p>
            
            <div className="verify-details-container">
              <div className="verify-detail-group">
                <span className="verify-label">Certificate ID</span>
                <span className="verify-value">{certificateData.certificate_id}</span>
              </div>
              <div className="verify-detail-group">
                <span className="verify-label">Student Name</span>
                <span className="verify-value">{certificateData.student_name}</span>
              </div>
              <div className="verify-detail-group">
                <span className="verify-label">Program</span>
                <span className="verify-value">{certificateData.program_title}</span>
              </div>
              {/* <div className="verify-detail-group">
                <span className="verify-label">Issue Date</span>
                <span className="verify-value">
                  {new Date(certificateData.issue_date).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </span>
              </div> */}
              {certificateData.student_email && (
                <div className="verify-detail-group">
                  <span className="verify-label">Student Email</span>
                  <span className="verify-value">{certificateData.student_email}</span>
                </div>
              )}
              {certificateData.student_phone && (
                <div className="verify-detail-group">
                  <span className="verify-label">Student Phone</span>
                  <span className="verify-value">{certificateData.student_phone}</span>
                </div>
              )}
            </div>

            <Link to="/" className="verify-button verify-button-success">Explore TrekVerse</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificateVerify;
